import React, { Component } from 'react'
import { StaticBox, LinkedInput } from 'components/basic'

class AccessEditor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      access: null
    }
  }
  componentDidMount () {
    this.setAccess(this.props.access)
  }
  componentWillReceiveProps(props) {
    if (props.access === this.props.access) return
    this.setAccess(props.access)
  }
  setAccess(access) {
    this.setState({access})
  }
  render () {
    if (!this.state.access) return false
    return (
      <StaticBox cols={12} icon='home' title={`${this.state.access.streetName} ${this.state.access.streetNumber}`}>
        <div className='row'>
          <div className='col-md-3'>
            <label>Street</label>
            <LinkedInput context={this} editable={false} path='access.streetName' />
          </div>
          <div className='col-md-3'>
            <label>Number</label>
            <LinkedInput context={this} editable={false} path='access.streetNumber' />
          </div>
          <div className='col-md-3'>
            <label>Littera</label>
            <LinkedInput context={this} editable={false} path='access.streetLittera' />
          </div>
          <div className='col-md-3'>
            <label>Zipcode</label>
            <LinkedInput context={this} editable={false} path='access.postalCode' />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-3'>
            <label>City</label>
            <LinkedInput context={this} editable={false} path='access.city' />
          </div>
          <div className='col-md-3'>
            <label>Apartment Number</label>
            <LinkedInput context={this} editable={false} path='access.mduApartmentNumber' />
          </div>
          <div className='col-md-3'>
            <label>Apartment Address</label>
            <LinkedInput context={this} editable={false} path='access.mduDistinguisher' />
          </div>
          <div className='col-md-3'>
            <label>Population</label>
            <LinkedInput context={this} editable={false} path='access.population' />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-3'>
            <label>Premises Type</label>
            <LinkedInput context={this} editable={false} path='access.premisesType' />
          </div>
          <div className='col-md-3'>
            <label>Access ID</label>
            <LinkedInput context={this} editable={false} path='access.accessId' />
          </div>
        </div>
      </StaticBox>
    )
  }
}

export default AccessEditor



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/access/AccessEditor.js